import entitlement$1 from './v3/index.js';
import './v3/playback.js';
import '@dtvgo/utils';
import '@dtvgo/error';
import './types.js';

function entitlement(backendAxiosInstance) {
  return {
    v3: entitlement$1(backendAxiosInstance)
  };
}

export { entitlement as default };
//# sourceMappingURL=index.js.map
